'use client';

import { cn } from '@/lib/ui/cn';
import { PropsWithChildren } from 'react';
import { IntakeProgressBar } from '../common/IntakeProgressBar';
import { WizardMobileBackButton } from '../WizardMobileBackButton';

type Props = PropsWithChildren & {
  currentStepIndex: number;
  totalSteps: number;
  hideProgress?: boolean;
  hideMobileBackButton?: boolean;
  mobileBackButton?: React.ReactNode;
  className?: string;
};

export const IntakeWizardLayout = ({
  children,
  currentStepIndex,
  totalSteps,
  hideProgress = false,
  hideMobileBackButton = false,
  mobileBackButton,
  className,
}: Props) => (
  <div className={cn('IntakeWizardLayout flex flex-1 flex-col', className)}>
    {!hideProgress && (
      <div className='IntakeWizardLayout__progress bg-[#F7F5EF] py-4'>
        <div className='mx-auto w-full max-w-2xl px-4 lg:px-8'>
          <IntakeProgressBar
            currentStep={currentStepIndex}
            totalSteps={totalSteps}
          />
        </div>
      </div>
    )}

    <div className='flex flex-1 flex-col'>
      {!hideMobileBackButton &&
        (mobileBackButton ?? <WizardMobileBackButton />)}

      <div
        className={cn(
          'IntakeWizardLayout__content',
          'flex flex-1 flex-col items-center lg:justify-center'
        )}
      >
        {children}
      </div>
    </div>
  </div>
);
